// extracted by mini-css-extract-plugin
module.exports = {"description":"Description_description__1hQzO","collapse":"Description_collapse__oA2Gr","drawer_btn":"Description_drawer_btn__2Q_W4","active":"Description_active__231tO"};